import type { Program, Statement } from './ast-node.model';

/**
 * Implementação do nó `Program` da AST.
 * Um `Program` representa uma sequência de declarações (`Statement`).
 * É o nó raiz da AST e também representa o conteúdo dentro de um `BlockStatement`.
 */
export class ProgramNode implements Program {
  public readonly type = 'Program';

  /**
   * @param body Um array de nós `Statement` que compõem o programa.
   */
  public constructor(public body: Statement[]) {}

  /**
   * Converte o programa de volta para sua representação em string,
   * juntando a representação em string de cada `Statement` em seu corpo.
   *
   * @returns A string de template correspondente ao programa.
   */
  public toString(): string {
    return this.body.map((statement) => statement.toString()).join('');
  }
}
